// latest

import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import LoginForm from "./LoginForm";
import ResetPasswordForm from "./ResetPasswordForm";
import FallScene from "./FallScene";
import { userPool } from "../cognito/UserPool";
import backgroundImageYellow from "../assets/images/backgroundImageYellow.png";
import { demoAdmin, demoTherapist, isDemoMode } from "../demo/demoMode";

function LoginPage() {
  const [formType, setFormType] = useState(
    () => localStorage.getItem("formType") || "login"
  );
  // const [isLoading, setIsLoading] = useState(true);
  const {
    currentNickname,
    setCurrentNickname,
    handleLogout,
    PlutonicuserID,
    loading,
    setLoading,
    userType,
    currentFormType,
    setCurrentFormType,
    setPlutonicuserID,
    setIsAuthenticated,
    setIsAdmin,
    setUserType,
  } = useContext(AuthContext);

  const loginDemo = (account) => {
    localStorage.setItem("currentNickname", account.nickname);
    localStorage.setItem("PlutonicuserID", account.id);
    localStorage.setItem("userType", account.userType);
    localStorage.setItem("userEmail", account.email);
    setCurrentNickname(account.nickname);
    setPlutonicuserID(account.id);
    setUserType(account.userType);
    setIsAdmin(account.userType === "Admin");
    setIsAuthenticated(true);
    navigate(account.userType === "Admin" ? "/admin" : "/");
  };

  // const [PlutonicuserID, setPlutonicuserID] = useState(() => localStorage.getItem('PlutonicuserID'));
  const navigate = useNavigate();

  useEffect(() => {
    const savedNickname = localStorage.getItem("currentNickname"); // Use consistent key
    const savedPlutonicuserID = localStorage.getItem("PlutonicuserID");

    // if (savedNickname && savedPlutonicuserID) {
    //   // console.log('[LoginPage] Restoring nickname and userID from localStorage:', savedNickname, savedPlutonicuserID);
    //   setCurrentNickname(savedNickname);
    //   // setPlutonicuserID(savedPlutonicuserID);
    //   navigate("/therapy-rooms"); // Redirect if authenticated
    //   return;
    // }

    if (savedNickname && savedPlutonicuserID && !loading) {
  navigate("/therapy-rooms");
}


    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
      cognitoUser.getSession((err, session) => {
        if (err || !session.isValid()) {
          // console.log('[LoginPage] Invalid session. Redirecting to login.');
          setCurrentFormType("login");
          setLoading(false);
          return;
        }

        cognitoUser.getUserAttributes((err, attributes) => {
          setLoading(false);
          if (err || !attributes) {
            // console.log('[LoginPage] Failed to fetch user attributes.');
            setCurrentFormType("login");
            return;
          }

          const nicknameAttr = attributes.find(
            (attr) =>
              attr.Name === "nickname" || attr.Name === "custom:nickname"
          );
          const userIDAttr = attributes.find(
            (attr) => attr.Name === "custom:PlutonicuserID"
          );

          const userNickname = nicknameAttr ? nicknameAttr.Value : "";
          const id = userIDAttr ? userIDAttr.Value : null;

          if (userNickname && id) {
            // console.log('[LoginPage] Session valid. Setting nickname and userID:', userNickname, id);
            setCurrentNickname(userNickname);
            // setPlutonicuserID(id);
            localStorage.setItem("currentNickname", userNickname);
            localStorage.setItem("PlutonicuserID", id);
            navigate("/therapy-rooms"); // Redirect after session validation
          }
        });
      });
    } else {
      setLoading(false);
    }
  }, [setCurrentNickname, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
  <div className="fall-page-background relative min-h-screen min-h-[100dvh] w-full flex flex-col items-center justify-start overflow-x-hidden">

    <FallScene />

    <Navbar
      currentNickname={currentNickname}
      handleLogout={handleLogout}
      setCurrentFormType={setCurrentFormType}
      showButtons={false}
      PlutonicuserID={PlutonicuserID}
    />

    <main className="login-page-main relative flex flex-1 flex-col items-center justify-center w-full z-10 px-4 pt-24 pb-10">
      <div className="relative flex flex-col justify-center items-center w-full max-w-[500px] p-2 sm:p-4">

        <div
          className="login-page-tagline relative text-center text-xl sm:text-2xl font-bold text-black mb-5 lg:hidden"
          style={{ fontFamily: "Poppins-Semibold, Poppins, sans-serif" }}
        >
          Therapy Built for You
        </div>

        <div className="relative mt-4">
          {currentFormType === "login" ? (
            <LoginForm
              onLoginSuccess={(nickname, id) => {
                localStorage.setItem("currentNickname", nickname);
                localStorage.setItem("PlutonicuserID", id);
                navigate("/therapy-rooms");
              }}
            />
          ) : (
            <ResetPasswordForm />
          )}
        </div>
        {isDemoMode && (
          <div className="mt-5 grid w-full max-w-sm grid-cols-2 gap-3 rounded-xl bg-white/90 p-3 shadow">
            <button className="rounded-lg bg-blue-600 px-3 py-2 font-semibold text-white" onClick={() => loginDemo(demoTherapist)}>
              Demo therapist
            </button>
            <button className="rounded-lg bg-slate-800 px-3 py-2 font-semibold text-white" onClick={() => loginDemo(demoAdmin)}>
              Demo admin
            </button>
          </div>
        )}
      </div>
    </main>
  </div>
);
}

export default LoginPage;
